import { Controller } from '@hotwired/stimulus';
import { Tooltip } from 'bootstrap';

// Connects to data-controller="report-schedule-logs"
export default class extends Controller {
  static targets = [ 'label', 'newRun', 'runUpdate', 'wrapper' ];

  applyCells( rowId, cells ) {
    const table = window.report_schedule_logs_table;

    if( !table ) return;

    const row = table.row( `#${ rowId }` );

    if( !row.any() ) return;

    this.disposeTooltips( row.node() );

    // no draw(), it resets paging
    Object.entries( cells ).forEach( ( [ name, html ] ) => {
      const cell = table.cell( `#${ rowId }`, `${ name }:name` );

      if( cell.any() ){ cell.data( html ); }
    } );

    this.initTooltips( row.node() );
  }

  disposeTooltips( node ) {
    if( !node ) return;

    node.querySelectorAll( '[data-bs-toggle="tooltip"]' ).forEach( ( el ) => {
      Tooltip.getInstance( el )?.dispose();
    } );
  }

  initTooltips( node ) {
    if( !node ) return;

    node.querySelectorAll( '[data-bs-toggle="tooltip"]' ).forEach( ( el ) => {
      Tooltip.getOrCreateInstance( el );
    } );
  }

  newRunTargetConnected() {
    this.render();
  }

  newRunTargetDisconnected() {
    this.render();
  }

  refresh() {
    this.newRunTargets.forEach( ( marker ) => marker.remove() );
    window.report_schedule_logs_table?.ajax.reload( null, false );
  }

  render() {
    if( !this.hasWrapperTarget || !this.hasLabelTarget ) return;

    const count = this.newRunTargets.length;

    this.wrapperTarget.classList.toggle( 'd-none', count === 0 );

    if( count === 0 ) return;

    this.labelTarget.textContent = `${ count } new log${ count === 1 ? '' : 's' } available`;
  }

  runUpdateTargetConnected( marker ) {
    this.applyCells( marker.dataset.row, JSON.parse( marker.dataset.cells ) );

    marker.remove();
  }
}
